
// import API from "../API";
import googleAnalysis from '@/js/lib/ga';

const mixAdd = {
    methods: {
        async add_cart(buynow, onlySelf = false) {
            try {
                //加购前的方法,商品详情页需要获取自定义字段的到加购请求
                let customFormProperties = null;
                if (this.mixAddCartBefore) {
                    customFormProperties = this.mixAddCartBefore();
                }
                let payload = { ...this.add_cart_data,addType:this.addType||'product.add' };
                let filesOff = false;
                if (customFormProperties) {
                    let { files, properties, resume } = customFormProperties;
                    if (!resume) { return }
                    filesOff = files && Object.keys(files).length
                    let propertiesOff = properties && Object.keys(properties).length
                    if (filesOff) {
                        let formData = new FormData();
                        for (const key in files) {
                            for (const subKey in files[key]) {
                                if (Object.hasOwnProperty.call(files[key], subKey)) {
                                    formData.append(`properties[${key}]`, files[key][subKey])
                                }
                            }
                        }
                        if (propertiesOff) {
                            for (const key in properties) {
                                formData.append(`properties[${key}]`, properties[key])
                            }
                        }
                        for (const key in payload) {
                            formData.append(key, payload[key])
                        }
                        payload = formData;
                    } else if (propertiesOff) {
                        payload.properties = properties;
                    }
                }
                this.disabled = true;
                let api = API.addcart;
                this.$('.buy_animate').addClass('buy_animate_action');
                if (parseInt(this.$("#app").css("padding-left")) > 0) {
                    this.$('.site-header').addClass('add_cart_animate_has_quicknav');
                }
                else {
                    this.$('.site-header').addClass('add_cart_animate');
                }
                this.$store.dispatch("change_button_disabled", true);
                if ((this.add_cart_list && this.add_cart_list.length) || ((buynow == 'athenaGroupProduct' || buynow == 'buynow') && this.group_checked_variants_info && this.group_checked_variants_info.length)) {
                    api = API.batchCart;
                    payload = { addType:this.addType||'product.batchCart'};
                    payload.product = [];
                    let formData = new FormData();
                    let filesOff = false;
                    let add_cart_list = this.add_cart_list && this.add_cart_list.length ? this.add_cart_list : [{ ...this.add_cart_data }];
                    if (customFormProperties) {
                        let { files, properties } = customFormProperties;
                        filesOff = files && Object.keys(files).length
                        let propertiesOff = properties && Object.keys(properties).length
                        if (filesOff) {
                            add_cart_list.forEach((item, index) => {
                                for (const key in files) {
                                    for (const subKey in files[key]) {
                                        if (Object.hasOwnProperty.call(files[key], subKey)) {
                                            formData.append(`product[${index}][properties][${key}]`, files[key][subKey])
                                        }
                                    }
                                }
                                if (propertiesOff) {
                                    for (const key in properties) {
                                        formData.append(`product[${index}][properties][${key}]`, properties[key])
                                    }
                                }
                                for (const key in item) {
                                    formData.append(`product[${index}][${key}]`, item[key])
                                }
                            })
                        } else if (propertiesOff) {
                            add_cart_list = add_cart_list.map(item => {
                                return { ...item, properties: properties }
                            })
                        }
                    }
                    let group_checked_variants_info = (buynow == 'athenaGroupProduct' || buynow == 'buynow') && this.group_checked_variants_info && this.group_checked_variants_info.length ? this.group_checked_variants_info : [];
                    if (filesOff) {
                        let add_cart_list_length = this.add_cart_list.length;
                        group_checked_variants_info.forEach((item, index) => {
                            for (const key in item) {
                                if (Object.hasOwnProperty.call(item, key)) {
                                    formData.append(`product[${add_cart_list_length + index}][${key}]`, item[key])
                                }
                            }
                        });
                        payload = formData;
                    } else {
                        payload.product.push(...add_cart_list, ...(!onlySelf ? group_checked_variants_info : []));
                    }
                }
                if (buynow == "buynow") {
                    if (filesOff) {
                        payload.append('clear', 1)
                        payload.append('addType', this.addType?this.addType+'.buynow':'product.buynow')
                    } else {
                        payload.clear = true;
                        payload.addType = this.addType?this.addType+'.buynow':'product.buynow';
                    }
                }
                let res = await this.$axios.post(api, payload);
                if (window.fbq) {
                    let content_category = [];
                    if (
                        this.now_variant?.categories &&
                        this.now_variant.categories.length
                    ) {
                        this.now_variant.categories.forEach((item) => {
                            content_category.push(item.name);
                        });
                    }
                    this.send_fb_event("AddToCart", {
                        content_type: "product_group",
                        content_ids: [this.add_cart_data?.product_id],
                        value: this.now_variant?.price,
                        num_items: this.add_cart_data?.quantity,
                        content_name: this.now_variant?.title,
                        currency: window.checkoutcurrency||"USD",
                        content_category,
                    });
                }
                if (window.ttq){
                    window.send_ttp_event("AddToCart",{
                        content_id: [this.add_cart_data?.product_id],
                        quantity: this.add_cart_data?.quantity,
                        value: this.now_variant?.price,
                        currency: window.checkoutcurrency||"USD"
                    })
                }
                if (window._learnq) {
                    this.klaviyo_addtocart(this.product, this.add_cart_data);
                }
                if (window.snaptr) {
                    window.snaptr('track', 'ADD_CART', {
                        'currency': window.checkoutcurrency||"USD",
                        'item_category': null,
                        'item_ids': [this.add_cart_data?.product_id],
                        'number_items': this.add_cart_data?.quantity,
                        'price': this.now_variant?.price,
                    })
                }
                // if (window.gtag) {
                //     window.gtag("event", "add_to_cart");
                // }
                googleAnalysis.event(googleAnalysis.gaAction.add, {
                    currency: res?.data?.currency,
                    value: this.now_variant?.price,
                    items: [{
                        id: this.add_cart_data?.product_id,
                        name: this.now_variant?.post_title,
                        category: this.product?.categories?.[0]?.name,
                        price: this.now_variant?.price,
                        variant: this.now_variant?.attrs?.[0]?.value
                    }]
                })
                this.$store.dispatch("change_news_cart", res.data);
                this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
                localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
                //加购完成回调函数。
                this.$emit('mixAddCartCallBack');
                if (this.cart_type == "inCart") {
                    this.$(".cartContent").animate(
                        { scrollTop: 0 },
                        500
                    );
                    this.disabled = false;
                    this.$store.dispatch("change_button_disabled", false);
                    return;
                };
                if (buynow == "buynow") {
                    this.cart_hash = this.getCookie("cart_hash");
                    this.toCheckInfo(this.cart_hash);
                    setTimeout(() => {
                        this.disabled = false;
                        this.$store.dispatch("change_button_disabled", false);
                    }, 5000);
                    if (window.fbq && res.data) {
                        let cartmes = res.data;
                        let cart_item = Object.values(cartmes.cart);
                        let content_ids = [];
                        let product_category_ids = [];
                        cart_item.forEach((item) => {
                            content_ids.push(item.product_id);
                            if (item.category_ids) {
                                product_category_ids = product_category_ids.concat(item.category_ids);
                            }
                        });
                        this.send_fb_event("InitiateCheckout", {
                            content_type: "product_group",
                            content_ids,
                            value: cartmes.cart_total,
                            num_items: cartmes.cart_contents_count,
                            currency: cartmes.currency ? cartmes.currency : "USD",
                        });
                    }
                    if (window.ttq && window.send_ttp_event) {
                        window.send_ttp_event('InitiateCheckout')
                    }
                } else if (
                    (this.theme == "venue" || this.theme == "showtime") &&
                    this.cart_type == "popup"
                ) {
                    this.disabled = false;
                    this.$store.dispatch("change_button_disabled", false);
                    this.$("#modalCart").modal("show");
                } else if (this.theme == "showtime" && this.cart_type == "drawer") {
                    this.disabled = false;
                    this.$store.dispatch("change_button_disabled", false);
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                    this.$("#collapseExample").collapse("show");
                } else if (
                    (this.theme == "vogue" || this.theme == 'athena') &&
                    (this.cart_type == "drawer" || this.cart_type == "popup")
                ) {
                    this.$store.dispatch("change_button_disabled", false);
                    if (this.theme != 'athena') {
                        this.showInlineCart();
                    }
                    this.disabled = false;
                } else {
                    window.open("/cart", "_self");
                    setTimeout(() => {
                        this.disabled = false;
                        this.$store.dispatch("change_button_disabled", false);
                    }, 5000);
                }
            } catch (error) {
                console.log(error, 'err');
                this.disabled = false;
                this.$store.dispatch("change_button_disabled", false);
                if (
                    error?.response?.data?.errors
                ) {
                    this.$message.error(Object.values(error.response.data.errors)[0][0]);
                } else if (error?.response?.data?.message) {
                    this.$message.error(error.response.data.message);
                }
            }
        },
    },
}
export default mixAdd;
